/* 🤖 this file was generated by svg-to-ts */
export const matIconRestorePage: {
  name: 'restore-page';
  data: string;
} = {
  name: 'restore-page',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7.17L18 8.83V20zm-9.55-9.43L7.28 9.4V13h3.6l-1.44-1.44a3.15 3.15 0 0 1 2.79-1.71 3.15 3.15 0 1 1 0 6.3 3.14 3.14 0 0 1-2.58-1.35H8.1a4.51 4.51 0 0 0 4.12 2.7c2.48 0 4.5-2.02 4.5-4.5s-2.02-4.5-4.5-4.5c-1.59 0-2.97.83-3.77 2.07z"/></svg>`
};
